import { render, staticRenderFns } from "./Qr_Ota.vue?vue&type=template&id=54a50ddc&scoped=true&"
import script from "./Qr_Ota.vue?vue&type=script&lang=js&"
export * from "./Qr_Ota.vue?vue&type=script&lang=js&"
import style0 from "./Qr_Ota.vue?vue&type=style&index=0&id=54a50ddc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a50ddc",
  null
  
)

export default component.exports